import SearchRounded from "@mui/icons-material/SearchRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { AppBar, Box, IconButton, InputBase, Toolbar, Tooltip, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import "./style.scss";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import { MenuRounded } from "@mui/icons-material";
import { useWindowDimensions } from "../../common/utils/useWindowDimensions";
import TemporaryDrawer from "./drawer";
import { useEffect, useState, useRef } from "react";
import CustomTooltip from "../../common/Tooltip";
import CustomBreadcrumbs from "./breadcrumbs";
import { setBreadcrumb, setBreadcrumbItems } from "../../store/breadcrumb/breadcrumbReducer";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../../routes";

const useStyles = makeStyles((theme) => ({
  appbar: {
    backgroundColor: "#d3d4d6",
    boxShadow: "none",
    height: 80,
    padding: "0 150px",
    zIndex: "1001",
    [theme.breakpoints.down("md")]: {
      height: 50,
      padding: "0px",
    },
  },
  toolbar: {
    height: "80px !important",
    minHeight: "unset",
    [theme.breakpoints.down("md")]: {
      height: 80,
      justifyContent: "space-between",
    },
  },
  appbar2: {
    top: "80px !important",
    backgroundColor: "#fff",
    // height: 50,
    height: 100,
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      top: "80px !important",
      height: 80,
      padding: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      top: "60px !important",
      height: 60,
    },
  },
  toolbar2: {
    height: "60px !important",
    minHeight: "unset",
    [theme.breakpoints.down("md")]: {
      height: 80,
      justifyContent: "space-between",
    },
  },
  logo: {
    height: 55,
    [theme.breakpoints.down("md")]: {
      height: 30,
    },
  },
  input: {
    // border: "2px solid rgba(255, 255, 255, 0.6)",
    border: "2px solid lightgrey",
    borderRadius: "10px",
    padding: "3px",
    [theme.breakpoints.down("md")]: {
      padding: "4px",
    },
  },
  iconPosition: {
    position: "absolute",
    right: 10,
    top: "50%",
    transform: "translateY(-50%)",
    color: "rgba(0,0,0,0.9)",
    height: "30px",
    width: "30px",
    [theme.breakpoints.down("sm")]: {
      height: 20,
      width: 20,
    },
  },
  citiisLogo: {
    // width: 256,
    // width: 221,
    [theme.breakpoints.down("md")]: {
      height: 30,
    },
    [theme.breakpoints.down("sm")]: {
      height: 30,
    },
    [theme.breakpoints.down("sm")]: {
      height: 20,
    },
  },
  links: {
    color: "#6767af",
    textTransform: "uppercase",
    marginLeft: 15,
    cursor: "pointer",
  },
  upperCitiisLogo: {
    height: 30,
  },
  logosWrapperBox: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexGrow: 0,
    },
  },
  arrow: {
    backgroundColor: "white",
    boxShadow: theme.shadows[8],
    padding: 15,
    borderRadius: 15,
  },
  tooltip: {
    backgroundColor: "white",
  },
  submenu: {
    display: "flex",
    flexDirection: "column",
  },
submenuItems: {
  fontSize: 16,
  fontFamily: "Helvetica",
  background: "white",
  border: "none",
  textTransform: "capitalize",
  marginTop: "5px",
  color: theme.palette.customGreen,
  padding: "8px 12px",
  textAlign: "left",
  cursor: "pointer",
  "&:hover": {
    fontWeight: "bold",
    background: "#f5f5f5",
  },
},
}));

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const breadcrumb = useSelector((state) => state.breadcrumb);
  const newAppbar = useRef(null);
  const headerLogo = useRef(null);
  const newBreadcrumb = useRef(null);
  const classes = useStyles();

const [open, setOpen] = useState(false);
const [nestedMenu, setNestedMenu] = useState(null);

  // window.onscroll = function () {
  //   scrollFunction();
  // };
  useEffect(() => {
  const handleScroll = () => {
    if (
      !newAppbar.current ||
      !headerLogo.current ||
      !newBreadcrumb.current
    ) {
      return;
    }

    if (window.scrollY > 50) {
      newAppbar.current.style.height = "57px";
      headerLogo.current.style.maxWidth = "17%";
      newBreadcrumb.current.style.marginTop = "0.4%";
    } else {
      newAppbar.current.style.height = "100px";
      headerLogo.current.style.maxWidth = "25%";
      newBreadcrumb.current.style.marginTop = "3.3%";
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  function scrollFunction() {
  if (
    !newAppbar.current ||
    !headerLogo.current ||
    !newBreadcrumb.current
  ) {
    return;
  }

  if (
    document.body.scrollTop > 50 ||
    document.documentElement.scrollTop > 50
  ) {
    newAppbar.current.style.height = "57px";
    headerLogo.current.style.maxWidth = "17%";
    newBreadcrumb.current.style.marginTop = "0.4%";
  } else {
    newAppbar.current.style.height = "100px";
    headerLogo.current.style.maxWidth = "25%";
    newBreadcrumb.current.style.marginTop = "3.3%";
  }
}

  const logos = [
    // {
    //   icon: require("../../assets/bannerLogos/republicFrance.png"),
    //   tooltip: "République Française",
    // },
    {
      icon: require("../../assets/bannerLogos/afd.png"),
      tooltip: "AFD",
    },
    { icon: require("../../assets/bannerLogos/german.png"), tooltip: "German Cooperation" },

    {
      icon: require("../../assets/bannerLogos/kfw.png"),
      tooltip: "KfW",
    },
    { icon: require("../../assets/bannerLogos/eu.png"), tooltip: "European Union" },

    {
      icon: require("../../assets/bannerLogos/globalGateway.png"),
      tooltip: "Global Gateway",
    },
    {
      icon: require("../../assets/bannerLogos/govtIndia.png"),
      tooltip: "Ministry of Housing and Urban Affairs",
    },
    // {
    //   // icon: require("../../assets/mohua.png"),
    //   icon: require("../../assets/emblem_header.png"),
    //   tooltip: "Ministry of Housing and Urban Affairs",
    // },

    {
      icon: require("../../assets/bannerLogos/smartCity.png"),
      tooltip: "Smart Cities Mission",
    },
    {
      icon: require("../../assets/bannerLogos/niua.png"),
      tooltip: "National Institute of Urban Affairs",
    },
    {
      icon: require("../../assets/bannerLogos/spects.png"),
      tooltip: "Swachh Bharat",
    },

    {
      icon: require("../../assets/bannerLogos/citiis.png"),
      tooltip: "CITIIS",
    },
  ];

  const logoscitiis2 = [
    {
      icon: require("../../assets/bannerLogos/afd.png"),
      tooltip: "Agence Francaise de Developpement",
    },
    { icon: require("../../assets/bannerLogos/eu.png"), tooltip: "European Union" },
    {
      icon: require("../../assets/bannerLogos/globalGateway.png"),
      tooltip: "Global Gateway",
    },
    {
      // icon: require("../../assets/mohua.png"),
      icon: require("../../assets/bannerLogos/govtIndia.png"),
      tooltip: "Ministry of Housing and Urban Affairs",
    },
    {
      icon: require("../../assets/bannerLogos/kfw.png"),
      tooltip: "KFW",
    },
    {
      icon: require("../../assets/bannerLogos/smartCity.png"),
      tooltip: "Smart Cities Mission",
    },
    {
      icon: require("../../assets/bannerLogos/niua.png"),
      tooltip: "National Institute of Urban Affairs",
    },
    {
      icon: require("../../assets/bannerLogos/citiis.png"),
      tooltip: "CITIIS",
    },
  ];

  const dimensions = useWindowDimensions();
  const mdScreen = dimensions.width < 900;

  const menu = [
    // {
    //   name: "CITIIS 2.0",
    //   submenu: [
    //     { name: "about", url: "/citiis2" },
    //     { name: "our work", url: "/ourwork2" },
    //   ],
    // },
    {
      name: "about",
      submenu: [
        // { name: "who we are", url: "/whoweare" },
        { name: "CITIIS 1.0", url: "/ourwork" },
        { name: "CITIIS 2.0", url: "/citiis22" },
        { name: "our team", url: "/ourteam" },
        { name: "our USPs", url: "/ourusp" },
        { name: "gallery", url: "/gallery" },
      ],
    },
   {
  name: "projects",
  submenu: [
    { name: "CITIIS 1.0", url: "/project-menu/citiis1" },
    {
      name: "CITIIS 2.0",
      submenu: [
        {
          name: "Component 1",
          url: "/project-menu/citiis2/component1",
        },
        {
          name: "Component 2",
          url: "/project-menu/citiis2/component2",
        },
      ],
    },
  ],
},
    {
      name: "resources",
      submenu: [
        { name: "Publications", url: "/publications" },
        { name: "Videos", url: "/videos" },
        { name: "MOOCs" },
        { name: "Blogs", url: "/blogs" },
        { name: "Webinars", url: "/webinars" },
      ],
    },
    { name: "contact", url: "/contactus" },
  ];

  const shareItems = [
    {
      button: FacebookShareButton,
      icon: FacebookIcon,
      url: "https://www.facebook.com/profile.php?id=100068273286928",
      tooltip: "Facebook page",
    },
    {
      button: LinkedinShareButton,
      icon: LinkedinIcon,
      url: "https://in.linkedin.com/school/national-institute-of-urban-affairs/",
      tooltip: "Linkedin page",
    },
    {
      button: TwitterShareButton,
      icon: TwitterIcon,
      url: "https://twitter.com/NIUA_India",
      tooltip: "Twitter handle",
    },
  ].map((item, index) => (
    <CustomTooltip title={item.tooltip}>
      <div>
        <item.icon
          style={{
            height: "30px",
            width: "30px",
            borderRadius: "50%",
            marginLeft: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            window.open(item.url, "_blank");
          }}
        />
      </div>
    </CustomTooltip>
    // </item.button>
  ));
  const ogitem = routes.find((item) => item.path === location.pathname);
  useEffect(() => {
console.log("pathname =",location.pathname);
  // Component 1
  if (location.pathname === "/project-menu/citiis2/component1") {
  dispatch(
  setBreadcrumbItems([
    {
      title: "Projects",
    },
    {
      title: "CITIIS 2.0",
    },
    {
      title: "Component 1",
      url: "/project-menu/citiis2/component1",
    },
  ])
);

    dispatch(setBreadcrumb(true));
    return;
  }

  // Component 2
  if (location.pathname === "/project-menu/citiis2/component2") {
   dispatch(
  setBreadcrumbItems([
    {
      title: "Projects",
    },
    {
      title: "CITIIS 2.0",
    },
    {
      title: "Component 2",
      url: "/project-menu/citiis2/component2",
    },
  ])
);
    dispatch(setBreadcrumb(true));

    return;
  }
  console.log("Component 2 breadcrumb dispatched");

console.log("breadcrumb", breadcrumb);

    const item = routes.find((item) => item.path === location.pathname);
    const newpathnamecitiis2 = location.pathname;
    console.log("newpathnamecitiis2", newpathnamecitiis2);
    console.log(item, "itemdata");
    if (item) {
      if (item?.name == "Our Work 2.0") {
        dispatch(
          setBreadcrumbItems([
            {
              title: "CITIIS 2.0",
              // url: item.path,
            },
            {
              title: "Our Work",
              url: item.path,
            },
          ])
        );
      } else {
        dispatch(
          setBreadcrumbItems([
            {
              title: item.name,
              url: item.path,
            },
          ])
        );
      }
    }

    if (location.pathname === "/") {
      dispatch(setBreadcrumb(false));
    } else {
      dispatch(setBreadcrumb(true));
    }
  }, [location.pathname]);

  return (
    <>
      <TemporaryDrawer
        shareItems={shareItems}
        menu={menu}
        logos={logos}
        open={open}
        setOpen={setOpen}
      />
      <AppBar position="fixed" className={classes.appbar}>
        <Toolbar className={classes.toolbar}>
          <Box className={classes.logosWrapperBox}>
            {mdScreen && (
              <img
                src={require("../../assets/citiis.png")}
                alt="citiis"
                className={classes.upperCitiisLogo}
                onClick={() => {
                  navigate("/");
                }}
              />
            )}
            {!mdScreen && (ogitem?.name == "Our Work 2.0" ||
              ogitem?.name == "About" ||
              ogitem?.name == "Component 1"
              ? logos
              : logos
            ).map((logo, index) => {
              // if (mdScreen) {
              //   // if (index !== 0) return "";
              //   if (index !== 4) return "";
              // }
              return (
                <CustomTooltip key={index} title={logo.tooltip}>
                  <IconButton
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    sx={{ cursor: "default !important" }}>
                    <img
                      src={logo.icon}
                      alt={index}
                      className={classes.logo}
                      style={{
                        height: logo.tooltip === "Ministry of Housing and Urban Affairs" && "90px",
                        maxHeight: logo.tooltip === "Ministry of Housing and Urban Affairs" && "60px"
                      }}
                    />
                  </IconButton>
                </CustomTooltip>
              );
            })}
          </Box>
          {mdScreen && (
            <>
              <IconButton onClick={() => setOpen(true)}>
                <MenuRounded sx={{ height: 30, width: 30 }} />
              </IconButton>
            </>
          )}
          {/* {!mdScreen && (
            <Box
              sx={{ marginLeft: 5, position: "relative" }}
              className={classes.searchWrapper}
            >
              <InputBase className={classes.input} />
              <SearchRounded className={classes.iconPosition} />
            </Box>
          )} */}
        </Toolbar>
      </AppBar>
      {!mdScreen && (
        <AppBar
          position="fixed"
          className={clsx(classes.appbar, classes.appbar2, "newmainappbar")}
          ref={newAppbar}>
          <Toolbar className={classes.toolbar2}>
            <IconButton
              disableFocusRipple
              disableRipple
              disableTouchRipple
              style={{ maxWidth: "25%" }}
              ref={headerLogo}>
              <img
                src={require("../../assets/citiis.png")}
                alt={"citiis"}
                className={clsx(classes.citiisLogo, "citiislogoheader")}
                onClick={() => {
                  navigate("/");
                }}
                style={{ width: "90%", marginLeft: "-5%" }}
              />
            </IconButton>
            <Box sx={{ flexGrow: 1 }}></Box>
            <Box
              className={classes.linkWrapper}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              {/* <Tooltip
                interactive
                arrow
                classes={{
                  tooltip: classes.tooltip,
                  tooltipArrow: classes.arrow,
                  arrow: classes.smallArrow,
                }}
                title={
                  <Box className={classes.submenu}>
                    <button
                      className={classes.submenuItems}
                      onClick={() => {
                       
                        navigate("/citiis-revampv2/citiis2");
                      }}
                    >
                      {"About"}
                    </button>
                    <button
                      className={classes.submenuItems}
                      onClick={() => {
                        
                        navigate("/citiis-revampv2/ourwork2");
                      }}
                    >
                      {"Our Work"}
                    </button>
                  </Box>
                }
              >
                <Typography
                 
                  variant="thinsmall"
                  className={clsx(classes.links, "dropdownlink 1st")}
                  style={{
                    fontSize: "17px",
                  }}
                >
                  {"citiis 2.0"}
                  <ArrowDropDownIcon />
                </Typography>
              </Tooltip> */}
              {menu.map((item, index) =>
                item.submenu ? (
                  <Tooltip
                    interactive
                    arrow
                    classes={{
                      tooltip: classes.tooltip,
                      tooltipArrow: classes.arrow,
                      arrow: classes.smallArrow,
                    }}
                    title={
                      <Box className={classes.submenu}>
                {item.submenu.map((subitem) =>
  subitem.submenu ? (
    <Box
      key={subitem.name}
      sx={{
        position: "relative",
        width: "100%",
      }}
      onMouseEnter={() => setNestedMenu(subitem.name)}
      onMouseLeave={() => setNestedMenu(null)}
    >
      <button
        className={classes.submenuItems}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        {subitem.name}
        <ArrowDropDownIcon
          style={{
            transform: "rotate(-90deg)",
          }}
        />
      </button>

      {nestedMenu === subitem.name && (
        <Box
          sx={{
            position: "absolute",
            left: "100%",
            top: 0,
            backgroundColor: "#fff",
            boxShadow: 3,
            borderRadius: 1,
            minWidth: "180px",
            display: "flex",
            flexDirection: "column",
            padding: "8px",
            zIndex: 9999,
          }}
        >
          {subitem.submenu.map((child) => (
            <button
              key={child.name}
              className={classes.submenuItems}
              onClick={() => {
                navigate(child.url);
                setNestedMenu(null);
              }}
            >
              {child.name}
            </button>
          ))}
        </Box>
      )}
    </Box>
  ) : (
    <button
      key={subitem.name}
      className={classes.submenuItems}
      onClick={() => {
        if (!subitem.url) return;
        navigate(subitem.url);
      }}
    >
      {subitem.name}
    </button>
  )
)}
                      </Box>
                    }>
                    <Typography
                      key={index}
                      variant="thinsmall"
                      className={clsx(classes.links, "dropdownlink 1st")}
                      style={{
                        fontSize: item.name === "CITIIS 2.0" && "17px",
                      }}>
                      {item.name}
                      <ArrowDropDownIcon />
                    </Typography>
                  </Tooltip>
                ) : (
                  <div>
                    <Typography
                      key={index}
                      variant="thinsmall"
                      className={clsx(classes.links, "dropdownlink")}
                      style={{ marginRight: "10px" }}
                      onClick={() => {
                        navigate(item.url);
                      }}>
                      {item.name}
                    </Typography>
                  </div>
                )
              )}
            </Box>
            {/* <Box
              className={classes.socialWrapper}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex" }}>{shareItems}</div>
            </Box> */}
            <Box
              sx={{
                marginLeft: 5,
                position: "relative",
                display: "none",
              }}
              className={classes.searchWrapper}>
              <InputBase className={classes.input} />
              <SearchRounded className={classes.iconPosition} />
            </Box>
          </Toolbar>
        </AppBar>
      )}
      {breadcrumb.open && <CustomBreadcrumbs newBreadcrumb={newBreadcrumb} />}
    </>
  );
};

export default Header;
